var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',{staticClass:"global_header"},[_c('div',{staticClass:"inner"},[_c('Logo'),_c('GlobalNavigation')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }